import Close from '@mui/icons-material/Close';
import { SnackbarKey, useSnackbar } from 'notistack';
import * as React from 'react';
import { TrackingEvent } from '../../Services/Tracking/TrackingService';
import IconButton from '../Form/Buttons/IconButton';
import styles from './NotificationsWrapper.module.scss';

interface ISnackbarCloseButtonProps {
    snackbarKey: SnackbarKey;
    track: TrackingEvent;
}

const SnackbarCloseButton: React.FC<ISnackbarCloseButtonProps> = (props) => {
    const { closeSnackbar } = useSnackbar();

    return (
        <IconButton
            handleClick={() => closeSnackbar(props.snackbarKey)}
            size="small"
            track={{ eventCategory: props.track.eventCategory, eventAction: `${props.track.eventAction}CloseClicked` }}
        >
            <Close className={styles.notifications_icon_close} />
        </IconButton>
    );
};
export default SnackbarCloseButton;
